import { useEffect, useState } from 'react';

import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { generateImageURL } from '@reducers/blobStorage';
import type { DashboardResultImageData } from '@api/domain/types';

interface UseManageDashboardRowImageParams {
  imageHash?: string | null;
  imageData?: DashboardResultImageData | null;
}

export const useManageDashboardRowImage = ({
  imageHash,
  imageData,
}: UseManageDashboardRowImageParams) => {
  const dispatch = useAppDispatch();
  const [uri, setUri] = useState<string | null>(null);

  useEffect(() => {
    if (!imageHash) {
      setUri(null);
      return;
    }

    let cancelled = false;

    (async () => {
      const link = await dispatch(
        generateImageURL({
          size: '_1x',
          cropped: imageData?.isCropped,
          item: { imageHash, extensionDerivative: imageData?.extensionDerivative ?? undefined },
          page: imageData?.pageNumber ?? 1,
        })
      );

      if (!cancelled) {
        setUri(typeof link === 'string' ? link : null);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [imageHash, imageData?.isCropped, imageData?.extensionDerivative, imageData?.pageNumber, dispatch]);

  return { uri };
};
